import { styled, alpha } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

export const InfoGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
  '& > div': {
    padding: theme.spacing(2.5),
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(theme.palette.common.white, 0.04)
        : theme.palette.grey[50],
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor:
        theme.palette.mode === 'dark'
          ? alpha(theme.palette.common.white, 0.16)
          : theme.palette.grey[300],
      backgroundColor:
        theme.palette.mode === 'dark'
          ? alpha(theme.palette.common.white, 0.06)
          : theme.palette.grey[100],
    },
  },
}));

export const InfoHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
}));

export const SummaryBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '8px',
  backgroundColor:
    theme.palette.mode === 'dark' ? alpha(theme.palette.success.main, 0.12) : '#f0fdf4',
  border: `1px solid ${
    theme.palette.mode === 'dark' ? alpha(theme.palette.success.main, 0.4) : '#bbf7d0'
  }`,
}));

export const SummaryRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1.5),
}));

export const TotalRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const ConfirmButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1.5),
  borderRadius: '8px',
  background: 'linear-gradient(to right, #06b6d4, #10b981)',
  color: 'white',
  '&:hover': {
    background: 'linear-gradient(to right, #0891b2, #059669)',
  },
}));
